import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { VisitDetailPhotos } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { Observable } from 'rxjs';

export class GetAiDermPhotoInfoEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  get(fileId: number): Observable<VisitDetailPhotos.AiDermResponse> {
    return this.http.get<VisitDetailPhotos.AiDermResponse>(
      `${this.env.constants.serverless_api_url}ai/autoderm/response?file_id=${fileId}`,
    );
  }
}
